// bank-misc-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1b.guided.useStatementAmount': 'Bruk beløpet fra utskriften ({amount})',
  'r1b.guided.checkedSuggestions': '{count} kontrollerte forslag',
  'r1b.import.read': 'Avlest: {amount}',
  'r1b.misc.bankAmountIncl': 'Bankbeløp inkl. {vat}',
  'r1b.misc.bankAmountExcl': 'Bankbeløp eks. {vat}',
  'r1b.misc.invoiceOption': '{number} · {customer} · gjenstår {remaining}',
  'r1b.posting.view': 'Se',
  'r1b.inbox.uploadingAnalysing': 'Lastes opp og analyseres',
  'r1b.surface.statementArchived': 'Bankutskriften er avstemt og arkivert',
  'r1b.surface.archiveFailed': 'Kunne ikke arkivere bankutskriften',
  'r1b.route.loadFailed': 'Kunne ikke laste siden.',
  'r1b.route.loading': 'Laster siden...',
});
